<template>
    <ClassroomLayout>
        <div class="message">
            <h3>Sorry. We couldn't find your next class.</h3>
            <p>
                You can only access a class that is happening now or is starting soon.
            </p>
            <p>
                If your class is today, please <a href="https://www.cococoders.com/contact-us">get in touch</a> and we'll
                help to resolve the issue.
            </p>
        </div>
    </ClassroomLayout>
</template>

<script setup>

import ClassroomLayout from "@/components/classroom/ClassroomLayout.vue";

</script>

<style lang="scss" scoped>
.message {
    text-align: center;

    h3 {
        margin-bottom: 50px;
    }
}
</style>
